import { UserType } from '@app/core/enums/user-type.enum';
import { IUserMe } from '@app/api/interfaces/user-me.interface';

export const userMeMockData: IUserMe = {
  id: '1',
  userName: 'MOCK',
  firstName: 'MOCK',
  lastName: 'MOCK',
  email: 'mock@mock.ua',
  type: UserType.Developer,
};
